import type {
  DiscoveryReadinessContract,
  DiscoveryReadinessValidationResponse,
} from "../types/discoveryReadiness";

export async function getDiscoveryReadiness(projectId: string): Promise<DiscoveryReadinessContract> {
  if (!projectId) {
    throw new Error("projectId is required to load discovery readiness");
  }

  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/checklists/discovery-readiness`,
  );
  const payload = (await response.json()) as DiscoveryReadinessContract & { ok?: boolean; error?: string };

  if (!response.ok || payload?.ok === false) {
    const message = payload?.error ?? `Failed to load discovery readiness (status ${response.status})`;
    throw new Error(message);
  }

  return payload;
}

export async function validateDiscoveryReadiness(
  projectId: string,
): Promise<DiscoveryReadinessValidationResponse> {
  if (!projectId) {
    throw new Error("projectId is required to validate discovery readiness");
  }

  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/checklists/discovery-readiness/validate`,
    { method: "POST" },
  );
  const payload = (await response.json()) as DiscoveryReadinessValidationResponse & { error?: string };

  if (!payload?.readiness) {
    const message = payload?.error ?? `Failed to validate discovery readiness (status ${response.status})`;
    throw new Error(message);
  }

  if (!response.ok || payload.ok === false) {
    return { ok: false, readiness: payload.readiness, errors: payload.errors };
  }

  return { ok: payload.ok ?? response.ok, readiness: payload.readiness, errors: payload.errors };
}
